export default __webpack_public_path__ + "static/finintcase3-509377e4054f33e2edfbf502ef7dc11c.png";